export default __webpack_public_path__ + "static/media/school.294d3c58.svg";